import { useIntl } from 'react-intl';

import { WikusAvatar } from '@wikus-ui/components/core/avatar';
import { WikusButton } from '@wikus-ui/components/core/button';
import { WikusItem, WikusSection } from '@wikus-ui/components/core/spacing';
import { WikusModelCard } from '@wikus-ui/components/complex/model-card';
import { WikusPanel } from '@wikus-ui/components/core/card';

import * as UserActions from '../../actions/user';

import { RootState } from '../../reducers';
import { User } from '../../model';
import { getInitials } from '@wikus-ui/utils';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { WikusHr } from '@wikus-ui/components/core/hr';

import * as SnackbarEventAction from '@wikus-ui/actions/snackbarEvent';

import { AdminHomeLayout } from './layout';
import { CreateCustomerUserForm } from '../../components/customer/users/createUser';
import { useActions } from '../../actions';

export const AdminUsersPage = () => {
  const intl = useIntl();
  const [loading, setLoading] = useState<string>();
  const [currentUser, setCurrentUser] = useState<User>();

  const user = useSelector((state: RootState) => state.user);
  const admins = useSelector((state: RootState) => state.userAdmins);
  console.log('admins', admins)

  const userActions: typeof UserActions = useActions(UserActions);
  const snackbarActions: typeof SnackbarEventAction =
    useActions(SnackbarEventAction);

  useEffect(() => {
    userActions.fetchAdmins();
  }, [])

  const editUser = useCallback((user: User) => {
    setCurrentUser(user);
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    });
  }, [setCurrentUser])

  return (
    <AdminHomeLayout>
      <CreateCustomerUserForm onClear={() => setCurrentUser(undefined)} value={currentUser} isSupport />

      <WikusSection spacingDirection="up">
        <WikusPanel
          title={intl.formatMessage({ id: 'admins.all' })}
        >
          {admins?.map((admin, index) => (
            <WikusItem spacingDirection="down" key={admin.id}>
              {index > 0 ? <WikusHr color="grey" /> : null}
              <WikusModelCard
                elevation={0}
                avatar={
                  <WikusAvatar size="large">
                    {getInitials(admin.lastName)}
                  </WikusAvatar>
                }
                buttons={admin.role === 'S' ? [
                  <WikusButton
                    color="primary"
                    onClick={() => editUser(admin)}
                  >
                    {intl.formatMessage({ id: 'edit' })}
                  </WikusButton>
                ] : []}
                details={[{
                  label: intl.formatMessage({
                    id: 'admins.details.email',
                  }),
                  value: admin.email,
                }, {
                  label: intl.formatMessage({
                    id: 'admins.details.role',
                  }),
                  value: admin.role,
                }, ...(
                  admin.supportCustomers?.length ? [{
                    label: intl.formatMessage({
                      id: 'admins.details.role',
                    }),
                    value: admin.supportCustomers.map(s => s.customerNumber).join(' | '),
                  }] : []
                )]}
                title={`${admin.firstName} ${admin.lastName}`}
              />
            </WikusItem>
          ))}
        </WikusPanel>
      </WikusSection>
    </AdminHomeLayout>
  );
};
